'use strict';

function EditSpendingBank() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _BankController];
  // @TODO access controller
  this._history = new History();
  this._spendingAcct = null;
  this._LOAN_DASHBOARD_PATH = '/member/dashboard/loans';

  this.init = function () {
    var _this = this;

    this._super();
    this._$iframe = $('.js--connect-to-bank-iframe');
    this._$exitVerifyDialog = $('.js--exit-verify-dialog');
    this._$exitDialogCta = $('.js--exit-dialog-cta');
    this._$cancelDialogCta = $('.js--cancel-dialog-cta');
    this._$spinner = $('.js--loading-spinner');
    this._$notification = $('#Notification');

    this._$exitDialogCta.on('click', function () {
      _this._$exitVerifyDialog.mogo().show();
    });
    this._$cancelDialogCta.on('click', function (event) {
      $(event.currentTarget).closest('[data-mogo-ui="Dialog"').mogo().hide();
    });
  };

  this.initAllReady = function () {
    var _this2 = this;

    this._super();
    this.getBankAccountsAssociatedWithProducts(BankAccount.productType.card, function (accts) {
      _this2._$spinner.hide();
      if (accts && accts.length > 0) {
        _this2._spendingAcct = accts[0];
        _this2._spendingAcct.relinkAccount(_this2._onAddLoanBankSuccess.bind(_this2), _this2._onFailure.bind(_this2));
      } else {
        _this2._onFailure();
      }
    });
    this.analytics.pushEvent('virtual-page-view');
  };

  this.destroy = function () {
    if (!this._$exitVerifyDialog.mogo().create) {
      this._$exitVerifyDialog.mogo().destroy();
    }
  };

  this._onAddLoanBankSuccess = function (data) {
    var _this3 = this;

    this.getBankById(this._spendingAcct.bankId, function (bk) {
      _this3.analytics.pushEvent('abs-status', { ABSBank: [bk.getBankName()] });
      location.replace('/portal/dashboard');
    });
  };

  this._onFailure = function (errorData) {
    if (errorData && errorData.errors && (errorData.errors[0].key === 'client_polling_timeout_client' || errorData.errors[0].key === 'rpc_timeout')) {
      this._$notification.mogo().create({
        isPersistent: true,
        msg: 'Hmm, we seem to be having an issue checking bank connections right now. Please try again later.',
        type: 'error'
      });
      this.analytics.forcePushEvent('link-bank-status', { LinkBankStatus: ['Bank Link Timeout'] });
      this._history.goToUrl(this._LOAN_DASHBOARD_PATH);
    } else if (errorData && errorData.isPlaidErrorPage) {
      this._history.goToUrl('/member/dashboard/loans/apply/bank-statement/error');
    } else {
      location.replace('/portal/dashboard');
    }
  };
}